/**
 * Get List
 */
export const EDITORIAL_BOARD_LIST = "EDITORIAL_BOARD_LIST";
export const EDITORIAL_BOARD_LIST_SUCCESS = "EDITORIAL_BOARD_LIST_SUCCESS";
export const EDITORIAL_BOARD_LIST_FAILURE = "EDITORIAL_BOARD_LIST_FAILURE";

/**
 * CREATE
 */
export const EDITORIAL_BOARD_CREATE = "EDITORIAL_BOARD_CREATE";
export const EDITORIAL_BOARD_CREATE_SUCCESS = "EDITORIAL_BOARD_CREATE_SUCCESS";
export const EDITORIAL_BOARD_CREATE_FAILURE = "EDITORIAL_BOARD_CREATE_FAILURE";

/**
 * GET BY ID
 */
export const EDITORIAL_BOARD_GET = "EDITORIAL_BOARD_GET";
export const EDITORIAL_BOARD_GET_SUCCESS = "EDITORIAL_BOARD_GET_SUCCESS";
export const EDITORIAL_BOARD_GET_FAILURE = "EDITORIAL_BOARD_GET_FAILURE";

/**
 * UPDATE BY ID
 */
export const EDITORIAL_BOARD_UPDATE = "EDITORIAL_BOARD_UPDATE";
export const EDITORIAL_BOARD_UPDATE_SUCCESS = "EDITORIAL_BOARD_UPDATE_SUCCESS";
export const EDITORIAL_BOARD_UPDATE_FAILURE = "EDITORIAL_BOARD_UPDATE_FAILURE";

/**
 * DELETE BY ID
 */
export const EDITORIAL_BOARD_DELETE = "EDITORIAL_BOARD_DELETE";
export const EDITORIAL_BOARD_DELETE_SUCCESS = "EDITORIAL_BOARD_DELETE_SUCCESS";
export const EDITORIAL_BOARD_DELETE_FAILURE = "EDITORIAL_BOARD_DELETE_FAILURE";